import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line import/no-internal-modules
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
// eslint-disable-next-line import/no-internal-modules
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import * as React from 'react';
export const TimezoneContext = React.createContext({});
export const LocalizationProvider = (props) => {
    const { timezone, ...muiProps } = props;
    const timezoneObj = React.useMemo(() => ({ timezone }), [timezone]);
    return (_jsx(TimezoneContext.Provider, { value: timezoneObj, children: _jsx(MuiLocalizationProvider, { dateAdapter: AdapterMoment, ...muiProps }) }));
};
